module.exports = __webpack_public_path__ + "img/wechat4.59263902.jpg";